import { render, staticRenderFns } from "./category-item.vue?vue&type=template&id=78b9b2dc&scoped=true&"
import script from "./category-item.vue?vue&type=script&lang=js&"
export * from "./category-item.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "78b9b2dc",
  null
  ,true
)

export default component.exports